<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5y6cHA/tc-custom/9781464208881.jpg?1731883537628" alt="This image is the cover for the book Point in the Market, Mamur Zapt Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Point in the Market, Mamur Zapt Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p>It's World War I. Britain has ruled Egypt since 1881 under a shadow government headed by its Agent and Consul General under the nominal authority of Egypt's hereditary ruler the Khedive. The head of the Secret Police is the Mamur Zapt, an office currently held by a Welshman, Captain Gareth Cadwallader Owen. And as the clouds of the war further darken Egypt's sun-lit skies, he has his hands full. On the professional front, there's all that commotion that started in Cairo's Camel Market. On the personal side, Owen has married his longtime lover, the lovely Pasha's daughter, Zeinab, a move with serious consequences for both of them and riddled with political and social pitfalls. Neither can be fully accepted by the other's culture and community. Against this, the perils of the Great War pale....</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Pearce
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5cdc0d8a